import { IsoDate, Path, Range } from '@softline/core';
import { Filter } from '../types/filter';

export interface DateRangeReferenceValue {
  range: Range<IsoDate>;
  reference: Range<IsoDate> | null;
}

/**
 * The period a page filter holds for `field`: a node that actually bounds the query - at the top
 * level or inside AND groups at any depth. A node under an OR is an alternative, not a bound, so it
 * is ignored. Null when the user cleared it, so callers fall back to their own default.
 */
export function readDateRangeFilter<T extends object>(
  filter: Filter<T> | null,
  field: Path<T>
): DateRangeReferenceValue | null {
  const node = findBoundingNode(filter, field);
  if (!node || node.type !== 'date' || node.operator !== 'between') return null;
  return { range: node.value, reference: node.reference ?? null };
}

function findBoundingNode<T extends object>(filter: Filter<T> | null, field: Path<T>): Filter<T> | null {
  if (!filter) return null;
  if (filter.type !== 'conditions') return filter.field === field ? filter : null;
  if (filter.operator !== 'AND') return null;
  for (const child of filter.filters) {
    const found = findBoundingNode(child, field);
    if (found) return found;
  }
  return null;
}
